/**
 * Directive for showing up union of permissions for users
 *
 */
angular.module('jv.Roles.permissions.directive', [])

    .directive('jvRolesPermissions', function() {
        return {
            scope: {  
                roleDetails: '=',
                filterState:'='
            },
            restrict: 'AE',
            template: '<div ng-repeat="permissionCategory in roleDetails">'+
                        '<div class="jv-sectionName margin-top-large row">{{permissionCategory.categoryLabel}}'+
                            '<a ng-click="permissionCategory.collapse = !permissionCategory.collapse" class="float-right">' +
                                 '<i ng-show="!permissionCategory.collapse || expandAll === false" class="icon icon-arrow-up dark-tri"></i>' +
                                  '<i ng-show="permissionCategory.collapse" class="icon icon-arrow-down dark-tri"></i>' +
                              '</a>' +
                        '</div>'+
                        '<div ng-hide="permissionCategory.collapse || expandAll === false">' + 
                            '<div ng-repeat="permission in permissionCategory.permissionTOs | filter: filterState" class="row inline-block padding-bottom-large border-border-bottom">'+
                                '<span class="col-4 regular font-medium padding-bottom-none">' +
                                    '<span class="left font-medium">{{permission.label}}</span>'+
                                '</span>'+
                                '<span class="col-1 padding-bottom-none">' +
                                '</span>' +
                                '<span class="col-7 padding-bottom-none padding-left-none">' +
                                    '<span>{{permission.description}}</span>'+
                                '</span>' +
                                '<span permission.accountableTOs" class="col-6 padding-left-xx-large padding-top-small padding-bottom-none padding-right-none inline-block">' +
                                    '<div ng-repeat="accountable in permission.accountableTOs">' +
                                        '<label ng-show="accountable.enable">' +
                                            '{{accountable.label}}' +
                                        '</label>' +
                                    '</div>' +
                                '</span>' +
                            '</div>' +
                        '</div>'+
                     '</div>'
                };
    });